import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { TotalItem } from '../../components';
import { Card, Grid } from '@material-ui/core';

const Total = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  const data = useSelector(({ transfer }) => transfer.data);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        alignItems="center"
        container
        justify="space-between"
      >
        {data &&
          data.total.map(total => {
            return <TotalItem
              key={total.name}
              totalData={total}
                   />;
          })}
      </Grid>
    </Card>
  );
};

Total.propTypes = {
  className: PropTypes.string
};

export default Total;

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  }
}));
